<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="loading-icon">
        <div class="spinner"></div>
      </div>

      <h1>Processing Payment...</h1>
      <p class="message">
        Please wait while we verify your payment. This usually takes a few
        seconds.
      </p>

      <!-- Processing Details Section -->
      <div class="summary-section">
        <h2>Processing Details</h2>
        <div class="summary-row">
          <span>Reference ID</span>
          <span>{{ referenceId }}</span>
        </div>
        <div class="summary-row">
          <span>Status</span>
          <span class="status-text">Verifying payment...</span>
        </div>
      </div>

      <div class="info-section">
        <p class="info-text">
          <vue-feather type="info" size="16" class="info-icon"></vue-feather>
          This process may take a few minutes. Please do not close this window.
        </p>
      </div>

      <div class="action-buttons">
        <button class="close-btn" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentLoadingModal",
  props: {
    referenceId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  text-align: center;
}

.loading-icon {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 64px;
  height: 64px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

h1 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #111827;
}

.message {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

h2 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #374151;
  text-align: left;
}

.summary-section {
  background-color: #f9fafb;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  text-align: left;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 14px;
  color: #6b7280;
}

.status-text {
  color: #3b82f6;
  font-weight: 500;
}

.info-section {
  background-color: #eff6ff;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.info-text {
  font-size: 14px;
  color: #1e40af;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.info-icon {
  color: #3b82f6;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.close-btn {
  padding: 0.75rem 1.5rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: #f9fafb;
  color: #374151;
}

.close-btn:hover {
  background-color: #f3f4f6;
}
</style>
